export class StringHelpers {
  /**
   * isNumeric tests a string and returns true when it's a decimal value
   */
  static isNumeric = (val: string) => !isNaN(+val);

  /**
   * capitaliseFirstLetter capitalises only the very first character of a string, leaving the
   * rest unedited
   */
  static capitaliseFirstLetter = (val: string) => val.charAt(0).toUpperCase() + val.slice(1);

  /**
   * toTitleCase upper-cases the first letter of every whitespace-separated word and
   * lower-cases the rest — e.g. 'silver' → 'Silver', 'agent express' → 'Agent Express',
   * 'GOLD' → 'Gold'. Original whitespace is preserved; empty strings pass through unchanged.
   */
  static toTitleCase = (val: string) =>
    val.replace(/\S+/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());
}
